<div class="mb-5">
  @if (alertsTableData.length > 0) {
    <app-ngb-table [config]="alertsTableConfig" [data]="alertsTableData"></app-ngb-table>
  }
</div>
